var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"redirect-page"},[_c('Loader',{attrs:{"size_prop":"10em"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }